import doubleLine_2_5 from "./img/doubleLine_2_5.png";
import doubleLine_3 from "./img/doubleLine_3.png";
import doubleLine_3_5 from "./img/doubleLine_3_5.png";
import grid_5 from "./img/grid_5.png";
import grid_6 from "./img/grid_6.png";
import grid_8 from "./img/grid_8.png";
import line_2_5 from "./img/line_2_5.png";
import line_3 from "./img/line_3.png";
import line_3_5 from "./img/line_3_5.png";

export default {
	line_2_5: line_2_5,
	line_3: line_3,
	line_3_5: line_3_5,
	doubleLine_2_5: doubleLine_2_5,
	doubleLine_3: doubleLine_3,
	doubleLine_3_5: doubleLine_3_5,
	grid_5: grid_5,
	grid_6: grid_6,
	grid_8: grid_8,
};
